var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_15007","data-name":"Group 15007","transform":"translate(-829 -2790)"},[React.createElement("circle",{"id":"Ellipse_3","data-name":"Ellipse 3","cx":"131","cy":"131","r":"131","transform":"translate(829 2790)","fill":"#fff","opacity":"0.3","key":0}),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M41,0,82,71H0Z","transform":"translate(1003 2880) rotate(90)","fill":"#fff","key":1})]));
}

IconPlay.defaultProps = {"width":"262","height":"262","viewBox":"0 0 262 262"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
